import { guid } from '../../../util';

export default class ServiceQueue {
  constructor() {
    this.innerQueue = [];
    this.innerSubscribers = [];
  }

  get queue() {
    return this.innerQueue;
  }

  set queue(value) {
    this.innerQueue = value;
    this.publish();
  }

  get subscribers() {
    return this.innerSubscribers;
  }

  set subscribers(value) {
    this.innerSubscribers = value;
    this.publish();
  }

  add(value) {
    this.queue = [...this.queue, value];
    return value;
  }

  delete(key) {
    this.queue = this.queue.filter(stack => {
      return stack.key !== key;
    });
  }

  deleteAll() {
    this.queue = [];
  }

  subscribe(next) {
    const key = guid();
    const nextSubscriber = {
      key,
      next,
    };
    this.subscribers = [...this.subscribers, nextSubscriber];
    return key;
  }

  unsubscribe(key) {
    this.subscribers = this.subscribers.filter(subscriber => {
      return subscriber.key !== key;
    });
  }

  unsubscribeAll() {
    this.subscribers = [];
  }

  publish() {
    if (this.subscribers.length !== 0) {
      this.subscribers.forEach(subscriber => {
        const { next } = subscriber;
        next(this.queue);
      });
    }
  }
}
